import PropTypes from 'prop-types';

export const SpeakerType = {
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.arrayOf(PropTypes.object)
};
